import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(() => ({
  currencyStyle: (/* props */) => ({
    fontSize: 'inherit',
    fontWeight: 'inherit',
    lineHeight: 'inherit',
    color: 'currentColor',
  }),
}))

export default useStyles
